// Desktop map/list switch. Nothing about the search changes, so it asks the
// server for nothing: the click paints the layout, the switcher and the address
// bar, exactly like mobile's overlay.
stimulusApp.register(
  "search-map-toggle",
  class extends Stimulus.Controller {
    static outlets = ["search-map"]
    static targets = ["mapLabel", "listLabel"]

    toggle() {
      const toMap = !document.body.classList.contains("google-maps-open")
      const column = document.querySelector(".search-results--container")

      document.body.classList.toggle("google-maps-open", toMap)
      document
        .querySelector(".search-and-results")
        .classList.toggle("search-and-results_fullwidth", toMap)
      document
        .querySelector(".google-maps--container")
        .classList.toggle("hidden", !toMap)
      document
        .querySelector(".search-results--spacer")
        .classList.toggle("hidden", toMap)
      column.classList.toggle("search-results--container_offers", !toMap)

      // `sticky-offers` only rides the column in list view, and dropping the
      // target is what unwinds whatever it left on the element.
      if (toMap) {
        column.removeAttribute("data-sticky-offers-target")
      } else {
        column.setAttribute("data-sticky-offers-target", "column")
      }

      this.element.classList.toggle("mode-switcher_list", toMap)
      this.element.classList.toggle("mode-switcher_map", !toMap)
      this.mapLabelTarget.classList.toggle("hidden", toMap)
      this.listLabelTarget.classList.toggle("hidden", !toMap)

      const url = new URL(location.href)
      if (toMap) {
        url.searchParams.set("view", "map")
      } else {
        url.searchParams.delete("view")
      }
      history.replaceState(history.state, "", url.href)

      if (toMap) this.searchMapOutlet.show()
      this.searchMapOutlet.scopeCounts()
      Activity.capture(`search-map ${toMap ? "open" : "close"}`)
    }
  },
)
